import { render, staticRenderFns } from "./AntarcticStationAmundsenScott.vue?vue&type=template&id=0a9e4d98&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports